module.exports = __webpack_public_path__ + "img/Frank Hinzen.97bb8faa.jpg";